import React from "react";

const ASP_Variables = () => {
  return (
    <div className="tutorial-page">
      <h1>ASP Variables</h1>
      <p>This is the ASP Variables page content.</p>
    </div>
  );
};

export default ASP_Variables;
